import axios from 'axios';

const base = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').replace(/\/api\/?$/, '').replace(/\/$/, '');
export const adminApi = axios.create({ baseURL: `${base}/api` });
adminApi.interceptors.request.use(config => {
  const token = sessionStorage.getItem('admin_token');
  config.headers.Authorization = token ? `Bearer ${token}` : undefined;
  return config;
});
adminApi.interceptors.response.use(response => response, error => {
  if (error.response?.status === 401 && !error.config?.url?.endsWith('/login')) {
    sessionStorage.removeItem('admin_token');
    window.dispatchEvent(new Event('admin-session-expired'));
  }
  return Promise.reject(error);
});
